import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from 'components/header/Header';
import Footer from 'components/footer/Footer';
import Content from 'components/Content';
import SearchBar from 'components/common/SearchBar';
import BundleTypeBar from 'components/common/BundleTypeBar';
import BundleList from 'components/bundles/BundleList';
import SearchKeywords from 'components/common/SearchKeywords';
import * as Const from 'util/constants';
import './AudioBundles.scss';

export class AudioBundles extends Component {
  componentDidMount() {
    this.syncTitle();
    this.syncDescription();
  }

  componentDidUpdate() {
    this.syncTitle();
    this.syncDescription();
  }

  syncTitle() {
    const { query } = this.props.match.params;
    if (query) {
      document.title = `Doodly: ${query} doodle audios`;
    } else {
      document.title = 'Doodly: Audio Bundles';
    }
  }

  syncDescription() {
    const { query } = this.props.match.params;
    const { relatedSearches } = this.props;
    const keywords = relatedSearches.map(item => item.keywords).slice(0, 5);

    let description = `Many ${query} bundles of audios including ${keywords.join(', ')} and much more.`;

    const descriptionEl = document.querySelector('meta[name="description"]');
    if (descriptionEl) {
      descriptionEl.setAttribute('content', description);
    } else {
      const descriptionEl = document.createElement('meta');
      descriptionEl.setAttribute('name', 'description');
      descriptionEl.setAttribute('content', description);
      document.head.append(descriptionEl);
    }
  }

  render() {
    const { query } = this.props.match.params;
    const { relatedSearches } = this.props;
    const keywords = relatedSearches.map(item => item.keywords);

    return (
      <div className="page-audio-bundles d-flex flex-column">
        <Header className={Const.TYPE_AUDIO_BUNDLES} />
        <Content className={Const.TYPE_AUDIO_BUNDLES}>
          <div className="top-content d-flex flex-column align-items-center">
            <h1 className="text-center">Find The Perfect Sound Effects For Your Videos.</h1>
            <BundleTypeBar className={Const.TYPE_AUDIO_BUNDLES} />
            <SearchBar className={Const.TYPE_AUDIO_BUNDLES} />
          </div>
          <div className="sheet">
            {keywords.length ? (
              <SearchKeywords keywords={keywords} title="Related:" type={Const.TYPE_AUDIO_BUNDLES} />
            ) : null}
            <h2 className="text-center">Most Popular Audio Sound Effect Bundles</h2>
            <div className="sheet-content row">
              <div className="col-lg-12 bundles">
                <BundleList orderBy="created_at desc" type={Const.TYPE_AUDIO_BUNDLES} initQuery={query} />
              </div>
            </div>
          </div>
        </Content>
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    currentQuery: state.bundles.searchFor,
    relatedSearches: state.bundles.relatedSearches
  };
};

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(AudioBundles);
